const feathers = require('@feathersjs/feathers');
const rest = require('@feathersjs/rest-client');
import axios from 'axios'
const auth = require('@feathersjs/authentication-client');
const API_URL = process.env.REACT_APP_API_URL;

const app = feathers();

const restClient = rest(API_URL);
app.configure(restClient.axios(axios));

// incase we later have to do authentication
app.configure(
  auth({}),
);

export default app;
